module.exports = __webpack_public_path__ + "static/img/年度重点项目.5261da02.png";